module.exports = __webpack_public_path__ + "static/banner_abad-58bf65806541eadc45bc5aab7e1599b6.jpg";